/* eslint-disable react/jsx-no-literals */
import React from 'react';
import Typography from 'carbon-react/lib/components/typography';

import * as styles from './growth-metric-card.scss';

export type GrowthMetricStatus = 'positive' | 'negative' | 'neutral' | 'warning' | 'disabled';

export interface GrowthMetricCardProps {
  label: string;
  value: string;
  status?: GrowthMetricStatus; // retained for API compatibility; not used for colour
  description?: string;
}

export const GrowthMetricCard = ({ label, value, description }: GrowthMetricCardProps) => {
  return (
    <div className={styles.growthMetricCard}>
      <Typography fontSize="14px" fontWeight="400" lineHeight="150%" mb={0} color="rgba(0,0,0,0.55)">
        {label}
      </Typography>
      <Typography fontSize="19px" fontWeight="700" lineHeight="125%" mb={0} color="#000000">
        {value}
      </Typography>
      {description && (
        <Typography fontSize="12px" fontWeight="400" lineHeight="150%" mb={0} color="rgba(0,0,0,0.55)">
          {description}
        </Typography>
      )}
    </div>
  );
};
